// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.header-row span {
  font-size: 16px;
  font-weight: bold;
}

.header-row select {
  padding: 5px;
  border-radius: 5px;
}

.profile-item,
.selected-profile-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.profile-item span,
.selected-profile-item span {
  flex-grow: 1;
}

#graph-container {
  width: 100%;
  height: calc(100vh - 70px);
  margin-top: 50px;
}

.move-button {
  position: absolute;
  top: 25px;
  right: 19px;
  cursor: grab;
}

.move-button.dragging {
  cursor: grabbing;
}

.dragging-column {
  opacity: 0.5;
}

/* Sticky search area */
.search-area {
  position: sticky;
  top: 53px; /* Stick below the header card (adjust value based on header's height) */
  /* z-index: 9; Ensure it stays below the header but above the content */
  /* background-color: white; Ensure the background doesn't overlap with scrolling content */
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05); */
  border-radius: 10px;
  width: 100%;
  /* margin-bottom: 10px; */
}

.search-row,
.deck-platform-row,
.checkbox-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

}

.search-input,
.platform-select {
  width: 81%;
  padding: 8px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.filter-button,
.icon-button,
.move-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.checkbox {
  opacity: 1;
  cursor: pointer;
  height: 12px;
  width: 12px;
}

.platform-checkbox-row label {
  font-size: smaller;
}

.platform-checkbox-row input[type="radio"] {
  appearance: radio;
  width: 16px;
  height: 16px;
  background-color: #f30000;
  border: 1px solid #dda1a1;
  border-radius: 2px;
  position: relative;
  margin-right: 5px;
}

.platform-checkbox-row input[type="radio"]:checked::before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #65ccb7;
  top: 3px;
  left: 3px;
  border-radius: 2px;
}

.post-card {
  border-radius: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 10px;
  /* position: relative; */
  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;
  /* z-index: 1; */
  box-sizing: border-box;
  margin-right: 6px;
}

.post-card.instagram,
.post-card.linkedin,
.post-card.twitter,
.post-card.tiktok {
  background-color: #fff;
  color: black;
}

.post-card.facebook {
  background: linear-gradient(90deg, #4267b2, #5fb9e2);
  color: white;
}

.post-card.instagram {
  background: linear-gradient(
    45deg,
    /* #774adf, */
    #9648be,
    #bc4596,
    /* #d8447a,
    #e94369,
    #ef4363,
    #ef535e, */
    /* #f07f52, */
    #f2c141
  );
  color: white;
}

.post-card.linkedin {
  background-color: #0076b2;
  color: white;
}

.post-card.twitter {
  background: linear-gradient(90deg, #000000, #666a6b);
  color: white;
}

.post-card.tiktok {
  background: linear-gradient(45deg, #9300c7, #69c9d0);
  color: white;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -4px;
}

.card-header .user-img {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}

.card-header .header-info {
  flex-grow: 1;
  margin-left: 8px;
}

.card-header h3 {
  margin-top: 0px;
  font-size: 14px;
}

.card-header p {
  margin-top: -13px;
  font-size: 14px;
  color: #ffffff !important;
}

.card-header .header-info .time {
  font-size: 0.8em;
  color: grey;
}

.card-header .platform-icon {
  width: 20px;
  height: 20px;
}

.card-header .social-icon a:hover img {
  transform: rotate(135deg);
}

.card-header .social-icon a:hover .facebook-icon {
  background: #3b5998;
  box-shadow: 0 0 5px #3b5998, 0 0 10px #3b5998;
}

.card-header .social-icon a:hover .instagram-icon {
  background: #e4405f;
  box-shadow: 0 0 5px #e4405f, 0 0 10px #e4405f;
}

.card-header .social-icon a:hover .linkedin-icon {
  background: #0077b5;
  box-shadow: 0 0 5px #0077b5, 0 0 10px #0077b5;
}

.card-header .social-icon a:hover .twitter-icon {
  background: #1da1f2;
  box-shadow: 0 0 5px #1da1f2, 0 0 10px #1da1f2;
}

.card-header .social-icon a:hover .tiktok-icon {
  background: #69c9d0;
  box-shadow: 0 0 5px #69c9d0, 0 0 10px #69c9d0;
}

.card-body {
  background: none;
}

.date-time {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  font-size: 0.9em;
  color: #e2e2e2;
}

.date-time-text {
  margin: 0;
}

.date,
.time {
  font-size: 0.9em;
}

.post-content {
  overflow: x;
  white-space: pre-wrap;
  font-size: 16px;
}

.card-body p {
  font-size: 14px;
  transition: transform 0.3s ease;
  width: 100%;
  text-align: justify;
  white-space: pre-wrap;
}


.card-footer {
  display: flex;
  justify-content: space-around;
}

.footer-item {
  font-size: 0.9em;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: transform 0.2s ease, color 0.2s ease;
}

.highlighted {
  font-weight: bold;
  font-size: 1.1em;
  font-family: Arial, sans-serif; /* or another bold and prominent font */
}

.footer-item:hover {
  transform: scale(1.2);
  color: #ff0000; /* or any color to highlight on hover */
}

/* Style for hashtags and mentions */
.highlighted-text {
  font-weight: bold;
  font-size: 1.1em;
  font-family: "Courier New", monospace; /* Bold and different font for differentiation */
  margin-right: 1px; /* Add a small space between text and the hashtag */
}

/* Animation for icons in footer */
.footer-item.animated-icon {
  transition: transform 0.2s ease, color 0.2s ease;
}

.footer-item.animated-icon:hover {
  transform: scale(2.2); /* Enlarges icon on hover */
  color: #ff4500; /* Changes color on hover */
}

.zoomed {
  transform: scale(1.1);
  z-index: 100;
}

.zoomed .card-body p {
  transition: transform 0.3s ease;
}

.zoomed .card-body:hover p {
  transform: scale(1.1);
}

/* Dropdown Button */
.dropbtn {
  background-color: #65ccb7;
  color: white;
  padding: 8px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  /* width: 100%; */
  text-align: center;
  z-index: 1000;
  box-sizing: border-box;
  border-radius: 5px;
}

.dropdown {
  position: relative;
  z-index: 9999; /* Ensure the dropdown wrapper is above other content */
}

/* Dropdown content */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 295px;
  max-height: 220px; /* Adjust max-height to ensure all platforms are visible */
  overflow-y: auto; /* Enable scrolling if content overflows */
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 9999; /* Higher than the deck or other components */
  top: 97px; /* Ensure the dropdown is placed below the button */
  left: 0;
  padding: 10px 0;
  border-radius: 5px;
}
.dropdown-content.show {
  display: block; /* Show when 'show' class is added */
}
/* Dropdown labels for each platform */
.dropdown-content label {
  color: black;
  padding: 10px;
  display: block;
  cursor: pointer;
}

/* Highlight effect when hovering over a platform */
.dropdown-content label:hover {
  background-color: #f1f1f1;
}

/* Ensure that clicking or hovering the button shows the dropdown */
.dropdown:hover .dropdown-content,
.dropdown:active .dropdown-content {
  display: block;
}

.content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 10px;
  margin-left: 275px; /* Adjusts margin from the sidebar */
  /* padding: 10px 0px; */
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 10px;
}

/* Scrollbar Styles for Chrome, Safari, and Edge */
.content::-webkit-scrollbar {
  /* width: 8px; */
  height: 10px; /* Set the width of the scrollbar */
}

.content::-webkit-scrollbar-track {
  background: #f1e3e3; /* Background of the scrollbar track */
  border-radius: 10px; /* Rounded corners of the scrollbar track */
}

.content::-webkit-scrollbar-thumb {
  background-color: #65ccb7; /* Scrollbar thumb color */
  border-radius: 10px; /* Rounded corners of the scrollbar thumb */
  border: 2px solid #f1f1f1; /* Add space around the thumb */
}

/* Hover effect to make the scrollbar more visible */
.content::-webkit-scrollbar-thumb:hover {
  background-color: #0e9e81; /* Darker color when hovered */
}

.vertical-card.main-column {
  flex-shrink: 0;
  width: 325px; /* Set this to match your main column width */
  height: calc(100vh - 44px); /* Makes it fit within the viewport */
}
.sub-column {
  width: 320px;
  height: calc(100vh - 106px);
  background: rgba(255, 255, 255, 0.85); /* Light transparency for glass effect */
  border-radius: 15px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  padding: 20px;
  position: relative;
  
  -webkit-backdrop-filter: blur(10px); /* Safari support */
  border: 2px solid transparent;
  background-clip: padding-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); /* Soft professional elevation */
}

.sub-column::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 12px;
  padding: 5px;
  background: linear-gradient(135deg, 
  #833AB4 0%,   /* Instagram Purple */
  #FD1D1D 25%,  /* Instagram Pink */
  #FDCB82 50%,  /* Instagram Orange */
  #1877F2 60%,  /* Facebook Blue */
  #111111 80%,  /* Twitter Dark (Black) */
  #69C9D0 90%,  /* TikTok Cyan */
  #EE1D52 100%  /* TikTok Magenta */
);


  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  opacity: 0.8;
}



/* 3D Effect to Elevate the Sub-column */
.sub-column::before {
  content: "";
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.05);
  z-index: -1;
}

/* Scrollbar Styling - Sleek and Minimal */
.sub-column::-webkit-scrollbar {
  width: 6px;
}

.sub-column::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

.sub-column::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #007BFF, #00C9FF);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.sub-column::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #0056b3, #0090ff);
}


/* Sticky Header */
.header-card {
  position: sticky;
  top: 0; /* Stick to the top of the vertical-card container */
  z-index: 10; /* Ensure it stays above other content */
  background-color: #ffffff;
  padding: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  text-align: center;
  /* margin-bottom: 10px; */
  max-width: 100%;
  word-wrap: break-word; /* Ensure wrapping within the header */
  overflow-wrap: break-word; /* Make sure the text wraps correctly */
  display: flex;
  justify-content: center; /* Center title */
  align-items: center;
  position: relative;
}

/* Ensuring title remains centered */
.header-card .header-content {
  flex: 1 1; /* Takes up available space, keeping text centered */
  text-align: center;
}

/* Title Styling */
.header-card .header-content h3 {
  margin: 0;
  font-size: 1.2em;
  font-weight: bold;
  white-space: normal; /* Allow text to wrap */
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: center;
  max-width: 90%; /* Prevent text from overflowing */
}

/* Subtitle (Optional) */
.header-card .header-content p {
  margin: 5px 0 0 0;
  font-size: 1em;
  color: #555;
}

/* 3-Dot Menu Icon */
.header-menu-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 5px;
  transition: 0.3s;
}

.header-menu-icon:hover {
  color: #333;
}


.new-post-card {
  border: 2px solid #69c9d0;
  height: 100%;
  align-items: center;
}

.post-card.transparent {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.comment-section {
  background: #3a5ba2;
  border-radius: 10px;
  padding: 10px;
  color: white;
  max-height: 300px;
  overflow-y: auto;
}

.comment {
  background: #2a3f5a;
  border-radius: 5px;
  padding: 8px;
  margin: 5px 0;
  font-size: 14px;
  color: whitesmoke;
  display: flex;
  flex-direction: column;
}

.comment .user {
  font-weight: bold;
  margin-bottom: 5px;
}

.comment .text {
  white-space: pre-wrap;
}

.comment .time {
  font-size: 0.8em;
  color: #ccc;
  text-align: right;
  margin-top: 5px;
}

.search-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
}

.search-button img {
  height: 35px;
}

.main-column {
  display: block;
}

/* ------------------------------------------------------------------ */
/* Base styles */
.hidden {
  display: none;
}

hr {
  width: calc(100% - 20px);
  border: 1px solid rgba(112, 112, 112, 0.6);
  margin-bottom: 20px;
  opacity: 30%;
}

.main-content {
  margin-left: 280px;
  padding: 10px;
  height: calc(100vh - 65px);
}

.popup-btn {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  top: 10px;
  left: 280px;
}

.popup-btn:hover {
  transform: translateX(10px);
}

/* Popup styles */
.popup {
  display: none;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 800px;
  height: auto;
  background-color: white;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  border-radius: 10px;
  overflow-y: auto;
}

.popup-content {
  position: relative;
  padding: 20px;
  height: 100%;
  box-sizing: border-box;
}

.close-btn {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 24px;
  cursor: pointer;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.tab-btn {
  flex: 1 1;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  background-color: #f0f0f0;
  border-radius: 5px 5px 0 0;
  margin-bottom: 10px;
}

.tab-btn:hover {
  background-color: #ddd;
}

.tab-btn.active {
  background-color: #65ccb7;
  color: white;
}

.popup-tab-content {
  display: none;
  overflow-y: auto;
  height: calc(100% - 80px);
}

.popup-tab-content.active {
  display: block;
}

/* Profiles list container */
.profiles-list,
.selected-profiles-list,
.selected-hashtags-list {
  overflow-y: auto;
  height: calc(100% - 80px);
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
}

/* Buttons */
.add-btn,
.remove-btn {
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 10px;
  width: 30px;
  height: 30px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.remove-btn {
  background-color: #ff6347;
}

.search-btn {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.search-btn:hover {
  background-color: #53b39b;
}

/* Card styles */
.vertical-card {
  background-color: white;
  padding: 10px;
  width: 325px; /* Ensure it’s consistent with your layout */
  height: calc(100vh - 44px); /* Makes it fit within the viewport */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  border-radius: 10px;

  margin-right: 10px; /* Spacing between the columns */
}

.posts-wrapper {
  background-color: white; /* Ensures a white background */
  top: 0;
  /* position: sticky; */
  overflow-x: hidden;
  overflow-y: scroll;
  /* z-index: 1; */
}
/* .sub-column {
    background-color: #f1f1f1;
    height: auto;
    padding: 7px 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    flex-direction: column;
    width: 300px;
    margin-left: 10px;
    display: inline-block;
} */

.focused {
  z-index: 10;
}

.background-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
}

/* Hover effects */
.post-card.facebook:hover,
.post-card.instagram:hover,
.post-card.linkedin:hover,
.post-card.twitter:hover,
.post-card.tiktok:hover {
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.9);
}

.add-column-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #007BFF, #0056b3); /* Gradient for sleek effect */
  color: white;
  border: none;
  border-radius: 50%; /* Makes it a perfect circle */
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3); /* Smooth shadow for depth */
  transition: all 0.3s ease-in-out;
}

/* Hover Effect */
.add-column-button:hover {
  background: linear-gradient(135deg, #0056b3, #004080);
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.4);
  transform: scale(1.1); /* Slightly enlarges button for better interaction */
}

/* Click Effect */
.add-column-button:active {
  transform: scale(0.95); /* Shrinks slightly when clicked */
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
}

/* Floating Animation */
@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
}

.add-column-button {
  animation: float 3s infinite ease-in-out;
}


@media (max-width: 480px) {
  .content {
    margin-left: 0;
    padding: 5px;
  }

  .vertical-card {
    width: 100%;
    max-width: 200px;
  }

  .popup {
    width: 100%;
    height: auto;
    padding: 0;
  }

  .popup-content {
    padding: 10px;
  }

  .popup-btn {
    font-size: 12px;
    padding: 8px 15px;
    left: 10px;
  }

  .search-btn {
    padding: 8px 10px;
    font-size: 14px;
  }
}

/* Style for the delete button */
.delete-column-button {
  position: absolute; /* Sets position to relative for moving within its normal flow */
 
  right: 13px; /* Moves the button 20px right from its normal position */
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.delete-column-button img {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.delete-column-button:hover img {
  transform: scale(1.1);
}



.dragging-column {
  opacity: 0.5;
  border: 2px dashed #ccc;
}

/* Ensure the content-wrapper uses flex for horizontal alignment */
.content-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.popup-error {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 0, 0, 0.8); /* Red background */
  color: white;
  padding: 20px;
  border-radius: 8px;
  font-size: 16px;
  z-index: 1000;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  animation: fadeInOut 3s forwards; /* Optional: add fade-in-out effect */
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.sticky-header {
  position: relative;
  top: -10px;
  z-index: 10;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px 10px 0 0;
}

/* Scrollbar Styles for Chrome, Safari, and Edge */
.posts-wrapper::-webkit-scrollbar {
  width: 8px; /* Set the width of the scrollbar */
}

.posts-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
  border-radius: 10px; /* Rounded corners of the scrollbar track */
}

.posts-wrapper::-webkit-scrollbar-thumb {
  background-color: #888; /* Scrollbar thumb color */
  border-radius: 10px; /* Rounded corners of the scrollbar thumb */
  border: 2px solid #f1f1f1; /* Add space around the thumb */
}

/* Hover effect to make the scrollbar more visible */
.posts-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Darker color when hovered */
}

.social-icon {
  width: 30px; /* Increase width */
  height: 30px; /* Increase height */
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-icon {
  width: 30px; /* Set width for larger icon */
  height: 30px; /* Set height for larger icon */
  transition: transform 0.2s ease-in-out;
}

.platform-icon:hover {
  transform: scale(1.2); /* Slightly enlarge on hover */
}

.date-time .sentiment-emoji {
  font-size: 1.1em; /* Adjust emoji size */
  margin-left: auto; /* Move it to the far right */
  color: #ffffff;
  font-weight: bold; /* Optional: color to distinguish the emoji */
}

/* Animation for icons in footer */
.footer-item.animated-icon {
  transition: transform 0.2s ease, color 0.2s ease;
}

.footer-item.animated-icon:hover {
  transform: scale(1.2); /* Enlarges icon on hover */
  color: #ff4500; /* Changes color on hover */
}
.sentiment-emoji {
  font-size: 1.1em; /* Adjust emoji size */
  margin-left: auto; /* Move it to the far right */
  color: #000000; /* Optional: color to distinguish the emoji */
  cursor: pointer;
}
.load-more-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px; /* Circular button width */
  height: 50px; /* Circular button height */
  padding: 12px;
  font-size: 20px;
  cursor: pointer;
  background-color: #65ccb7;
  color: white;
  border: none;
  border-radius: 50%; /* Makes the button circular */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */
  transition: all 0.3s ease;
  position: relative; /* So the tooltip is correctly positioned */
  margin-left: 43%;
}
.load-more-button {
  animation: float 3s infinite ease-in-out;
}
.load-more-button:hover {
  background-color: #42a894;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2); /* Enhanced shadow on hover */
  transform: scale(1.05); /* Slightly scale the button on hover */
}

.load-more-button:focus {
  outline: none;
}

/* If you're using Font Awesome icons, the icon class should be like this */
.load-more-icon {
  font-size: 24px;
  color: white; /* Make sure the icon is white */
  display: inline-flex; /* Ensures it aligns well within the button */
  align-items: center;
  justify-content: center;
  margin: 0; /* Remove any default margin that may mess up alignment */
}

/* Tooltip styling */
.load-more-button[title]:hover::after {
  content: attr(title);
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 10px;
  background-color: #333;
  color: white;
  border-radius: 5px;
  font-size: 14px;
  white-space: nowrap;
 
}

.loading-indicator {
  text-align: center;
  font-size: 18px;
  color: #888;
  margin: 20px 0;
}

/* General styles for image container */
.attached-images {
    margin-top: 10px;
    display: grid;
    gap: 10px;
  }
  
  /* Single image layout */
  .grid-1 {
    grid-template-columns: 1fr;
    justify-items: center;
    align-items: center;
  }
  
  /* Two images in a horizontal layout */
  .grid-2 {
    grid-template-columns: 1fr 1fr;
    justify-items: center;
  }
  
  /* Three or more images layout */
  .grid-3-special {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
  
 /* Modal styles - set to appear above all components */
 .image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); /* Adjust opacity if needed */
  display: flex;
  justify-content: center;
  align-items: center;

}

/* Modal content styling */
.image-modal-content {
  position: relative;
  width: 80%; /* Adjust based on preference */
  height: 80%; /* Adjust based on preference */
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden; /* Adjust if your content needs scrolling */
}
/* Close button styling */
.image-close-modal {
  position: absolute;
  top: 20px; /* More padding to ensure it's easily clickable */
  right: 20px;
  background: none;
  border: none;
  font-size: 30px; /* Larger size for better interaction */
  color: white; /* Ensure visibility against the modal background */
  cursor: pointer;
}

/* Modal images container */
.modal-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}


/* Individual modal images */
.modal-img {
  max-width: 100%; /* Full width of the content area */
  max-height: 100%; /* Full height without overflowing the modal */
  object-fit: contain; /* Adjust to 'cover' if you want it to fill the area */
  border-radius: 8px; /* Maintain rounded corners if desired */
}

.post-img {
  width: 100%; /* Use 100% to make the image responsive within its container */
  height: auto; /* Set height to auto to maintain the aspect ratio */
  object-fit: cover; /* Cover ensures the image covers the container without distortion */
  border-radius: 8px; /* Keeps the existing border-radius for rounded corners */
  /* z-index: 100000 */
  ;
}

.highlight {
  background-color: yellow;
  font-weight: bold;
  color: red;
}

.toggle-text-button-deck {
  color: #6eaeff;  /* Vibrant blue color for normal state */
  cursor: pointer;
  background: none;  /* Remove any background */
  border: none;  /* Remove borders */
  padding: 5px;  /* Adequate padding for better clickability */
  outline: none;  /* Remove focus outline */
  font-size: 16px;  /* Make the font size a bit larger for better readability */
  transition: color 0.3s ease;  /* Smooth transition for color change */
}

.toggle-text-button-deck:hover,
.toggle-text-button-deck:focus {
  color: white;  /* A darker shade of blue on hover/focus for better visibility */
  text-decoration: underline;  /* Adds an underline on hover/focus to indicate it's clickable */
}

/* Add to your global CSS */
/* *, *:before, *:after {
  box-sizing: border-box; 
} */




.submit-search-button {
  background: none; /* Remove background color */
  border: none; /* Remove border */
  color: inherit; /* Use the parent's text color */
  cursor: pointer;
  display: flex; /* Allows for flexbox centering */
  align-items: center; /* Center content vertically */
  justify-content: center; /* Center content horizontally */
  padding: 0; /* Remove padding */
  width: 30px; /* Set a fixed width */
  height: 30px; /* Set a fixed height */
  overflow: hidden; /* Keeps everything neat */
  margin-left: 20px;
  margin-right:-26 ; /* Move the button a bit to the right */
}

.submit-search-button span {
  display: inline-block; /* Allows independent animation of the span */
  font-size: 18px; /* Set initial size of the emoji */
  animation: pulse 2s infinite ease-in-out; /* Animation applied continuously */
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1); /* Original size */
  }
  50% {
    transform: scale(1.5); /* Increased size */
  }
}

/*_______________________________________________________________________________________________________________________________*/

/* Loader */
/* Loader Styles */
.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


/* copy link button */

.copy-post-link-button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #fafafa; /* Matching theme color */
  transition: color 0.3s ease-in-out;
}

.copy-post-link-button:hover {
  color: #65ccb7; /* Darker on hover */
}

.copy-success {
  color: rgb(247, 247, 247);
  font-size: 12px;
  margin-left: 5px;
}

/* video playing styles */
/* Style for video container */
/* Style for video container */
/* Video Styles */
.attached-videos {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}

.video-container {
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.post-video {
  width: 100%;
  max-height: 250px;
  border-radius: 8px;
  background: black;
  object-fit: cover;
}



.open-post-icon:hover {
  color: #65ccb7 !important;
}



.date-picker {
  padding: 8px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #fff;
}
.date-picker:hover {
  border-color: #65ccb7;
}

/* Modal Styling */


/* Animation for Modal Appearance */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateX(-50%) scale(0.9); /* Starts slightly smaller */
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) scale(1); /* Modal settles at normal size */
  }
}



/* Elegant, Professional Highlight */
.highlight {
  background-color: rgba(255, 223, 88, 0.5); /* Soft golden yellow */
  color: #333; /* Dark text for readability */
  font-weight: bold;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background-color 0.3s ease-in-out;
}

/* Slight glow effect for better visibility */
.highlight:hover {
  background-color: rgba(255, 200, 50, 0.7); /* Slightly stronger yellow on hover */
}
.sub-column-search-input {
  width: 90%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  margin-bottom: 5px;
  margin-top: 5px;
  transition: all 0.3s ease-in-out;
  outline: none;
  background: #f9f9f9;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.sub-column-search-input:focus {
  border-color: #007bff;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);
}

.sub-column-search-input::placeholder {
  color: #999;
  font-style: italic;
}

.sub-column-search-input:hover {
  border-color: #888;
}



/* Advanced Aesthetic Spinner */
.spinner {
  width: 32px;
  height: 32px;
  display: inline-block;
  position: relative;
}

.spinner::before,
.spinner::after {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  animation: pulse 1.2s infinite ease-in-out;
}

.spinner::before {
  border: 4px solid rgba(0, 123, 255, 0.2);
  animation-delay: -0.6s;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
}

.spinner::after {
  border: 4px solid rgba(0, 123, 255, 0.8);
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}

/* Spin Animation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Subtle Pulse Animation */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
}


/* Container for the "No Posts Found" message */
.no-posts-container {
  display: flex;
  justify-content: center;
  align-items: center;
  
  padding: 20px;


  animation: fadeIn 0.5s ease-in-out; /* Smooth fade-in animation */
}

/* Content inside the container */
.no-posts-content {
  text-align: center;
  max-width: 400px;
  padding: 20px;
}

/* Icon styling */
.no-posts-icon {
  margin-bottom: 20px;

}

.no-posts-icon svg {
  width: 64px;
  height: 64px;
  color: #6b7280; /* Gray color for the icon */
}

/* Title styling */
.no-posts-title {
  font-size: 24px;
  font-weight: 600;
  color: #1f2937; /* Dark gray for the title */
  margin-bottom: 10px;
}

/* Description styling */
.no-posts-description {
  font-size: 16px;
  color: #6b7280; /* Gray for the description */
  line-height: 1.5;
}

/* Keyframes for animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


`, "",{"version":3,"sources":["webpack://./src/styles/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,SAAS,EAAE,wEAAwE;EACnF,uEAAuE;EACvE,0FAA0F;EAC1F,gDAAgD;EAChD,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;;AAEb;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,mEAAmE;EACnE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;;EAIE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE;;;;;;;;;;;GAWC;EACD,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,oDAAoD;EACpD,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B,EAAE,uCAAuC;AACzE;;AAEA;EACE,qBAAqB;EACrB,cAAc,EAAE,uCAAuC;AACzD;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC,EAAE,gDAAgD;EACvF,iBAAiB,EAAE,mDAAmD;AACxE;;AAEA,kCAAkC;AAClC;EACE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,cAAc,EAAE,2BAA2B;AAC7C;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa,EAAE,uDAAuD;AACxE;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB,EAAE,0DAA0D;EAC7E,gBAAgB,EAAE,0CAA0C;EAC5D,+CAA+C;EAC/C,aAAa,EAAE,6CAA6C;EAC5D,SAAS,EAAE,mDAAmD;EAC9D,OAAO;EACP,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc,EAAE,oCAAoC;AACtD;AACA,sCAAsC;AACtC;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,kBAAkB,EAAE,oCAAoC;EACxD,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,YAAY,EAAE,mCAAmC;AACnD;;AAEA;EACE,mBAAmB,EAAE,sCAAsC;EAC3D,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,mBAAmB,EAAE,2CAA2C;EAChE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA,oDAAoD;AACpD;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,cAAc;EACd,YAAY,EAAE,6CAA6C;EAC3D,0BAA0B,EAAE,qCAAqC;AACnE;AACA;EACE,YAAY;EACZ,2BAA2B;EAC3B,qCAAqC,EAAE,wCAAwC;EAC/E,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;;EAElB,mCAAmC,EAAE,mBAAmB;EACxD,6BAA6B;EAC7B,4BAA4B;EAC5B,2CAA2C,EAAE,gCAAgC;AAC/E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ;;;;;;;;CAQD;;;EAGC,sEAAsE;EACtE,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd;;;;AAIA,wCAAwC;AACxC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;AACvD;;;AAGA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,MAAM,EAAE,oDAAoD;EAC5D,WAAW,EAAE,wCAAwC;EACrD,yBAAyB;EACzB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,qBAAqB,EAAE,sCAAsC;EAC7D,yBAAyB,EAAE,uCAAuC;EAClE,aAAa;EACb,uBAAuB,EAAE,iBAAiB;EAC1C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,SAAO,EAAE,oDAAoD;EAC7D,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EAAE,uBAAuB;EAC5C,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc,EAAE,kCAAkC;AACpD;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,wCAAwC;EACxC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,uEAAuE;AACvE,gBAAgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA,YAAY;AACZ;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY,EAAE,4CAA4C;EAC1D,0BAA0B,EAAE,qCAAqC;EACjE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,uBAAuB,EAAE,+BAA+B;EACxD,MAAM;EACN,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;;;;;;;;GAUG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;;AAEA,kBAAkB;AAClB;;;;;EAKE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qDAAqD,EAAE,8BAA8B;EACrF,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAE,8BAA8B;EAClD,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C,EAAE,4BAA4B;EACzE,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,qDAAqD;EACrD,2CAA2C;EAC3C,qBAAqB,EAAE,oDAAoD;AAC7E;;AAEA,iBAAiB;AACjB;EACE,sBAAsB,EAAE,kCAAkC;EAC1D,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,KAAK,0BAA0B,EAAE;EACjC,MAAM,2BAA2B,EAAE;EACnC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE,kBAAkB,EAAE,gEAAgE;;EAEpF,WAAW,EAAE,yDAAyD;EACtE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sCAAsC,EAAE,mBAAmB;EAC3D,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC,EAAE,qCAAqC;AACzE;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,yCAAyC;EACzC,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,kDAAkD;AAClD;EACE,UAAU,EAAE,mCAAmC;AACjD;;AAEA;EACE,mBAAmB,EAAE,sCAAsC;EAC3D,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA;EACE,sBAAsB,EAAE,0BAA0B;EAClD,mBAAmB,EAAE,2CAA2C;EAChE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA,oDAAoD;AACpD;EACE,sBAAsB,EAAE,8BAA8B;AACxD;;AAEA;EACE,WAAW,EAAE,mBAAmB;EAChC,YAAY,EAAE,oBAAoB;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW,EAAE,8BAA8B;EAC3C,YAAY,EAAE,+BAA+B;EAC7C,sCAAsC;AACxC;;AAEA;EACE,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA;EACE,gBAAgB,EAAE,sBAAsB;EACxC,iBAAiB,EAAE,6BAA6B;EAChD,cAAc;EACd,iBAAiB,EAAE,6CAA6C;AAClE;;AAEA,kCAAkC;AAClC;EACE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB,EAAE,2BAA2B;EAClD,cAAc,EAAE,2BAA2B;AAC7C;AACA;EACE,gBAAgB,EAAE,sBAAsB;EACxC,iBAAiB,EAAE,6BAA6B;EAChD,cAAc,EAAE,6CAA6C;EAC7D,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,0BAA0B;EACvC,YAAY,EAAE,2BAA2B;EACzC,aAAa;EACb,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB,EAAE,8BAA8B;EAClD,yCAAyC,EAAE,kBAAkB;EAC7D,yBAAyB;EACzB,kBAAkB,EAAE,2CAA2C;EAC/D,gBAAgB;AAClB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,yCAAyC,EAAE,6BAA6B;EACxE,sBAAsB,EAAE,uCAAuC;AACjE;;AAEA;EACE,aAAa;AACf;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,YAAY,EAAE,gCAAgC;EAC9C,oBAAoB,EAAE,6CAA6C;EACnE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS,EAAE,yDAAyD;AACtE;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,uCAAuC;AACvC;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;EACX;;EAEA,wBAAwB;EACxB;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA,sCAAsC;EACtC;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA,gCAAgC;EAChC;IACE,qCAAqC;IACrC,SAAS;EACX;;CAED,sDAAsD;CACtD;EACC,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oCAAoC,EAAE,6BAA6B;EACnE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU,EAAE,+BAA+B;EAC3C,WAAW,EAAE,+BAA+B;EAC5C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,2CAA2C;AAC/D;AACA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS,EAAE,iDAAiD;EAC5D,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe,EAAE,uCAAuC;EACxD,YAAY,EAAE,mDAAmD;EACjE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;;AAGA,4BAA4B;AAC5B;EACE,eAAe,EAAE,mCAAmC;EACpD,gBAAgB,EAAE,8CAA8C;EAChE,mBAAmB,EAAE,sDAAsD;EAC3E,kBAAkB,EAAE,wCAAwC;AAC9D;;AAEA;EACE,WAAW,EAAE,+DAA+D;EAC5E,YAAY,EAAE,oDAAoD;EAClE,iBAAiB,EAAE,oEAAoE;EACvF,kBAAkB,EAAE,yDAAyD;EAC7E,oBAAoB;;AAEtB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc,GAAG,wCAAwC;EACzD,eAAe;EACf,gBAAgB,GAAG,0BAA0B;EAC7C,YAAY,GAAG,mBAAmB;EAClC,YAAY,GAAG,6CAA6C;EAC5D,aAAa,GAAG,yBAAyB;EACzC,eAAe,GAAG,2DAA2D;EAC7E,2BAA2B,GAAG,uCAAuC;AACvE;;AAEA;;EAEE,YAAY,GAAG,gEAAgE;EAC/E,0BAA0B,GAAG,gEAAgE;AAC/F;;AAEA,2BAA2B;AAC3B;;GAEG;;;;;AAKH;EACE,gBAAgB,EAAE,4BAA4B;EAC9C,YAAY,EAAE,kBAAkB;EAChC,cAAc,EAAE,gCAAgC;EAChD,eAAe;EACf,aAAa,EAAE,iCAAiC;EAChD,mBAAmB,EAAE,8BAA8B;EACnD,uBAAuB,EAAE,gCAAgC;EACzD,UAAU,EAAE,mBAAmB;EAC/B,WAAW,EAAE,sBAAsB;EACnC,YAAY,EAAE,uBAAuB;EACrC,gBAAgB,EAAE,0BAA0B;EAC5C,iBAAiB;EACjB,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA;EACE,qBAAqB,EAAE,6CAA6C;EACpE,eAAe,EAAE,kCAAkC;EACnD,wCAAwC,EAAE,mCAAmC;AAC/E;;AAEA;EACE;IACE,mBAAmB,EAAE,kBAAkB;EACzC;EACA;IACE,qBAAqB,EAAE,mBAAmB;EAC5C;AACF;;AAEA,kIAAkI;;AAElI,WAAW;AACX,kBAAkB;AAClB;EACE,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA,qBAAqB;;AAErB;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc,EAAE,yBAAyB;EACzC,kCAAkC;AACpC;;AAEA;EACE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB,8BAA8B;AAC9B,8BAA8B;AAC9B,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;;;AAIA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;;;AAGlB,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,sCAAsC,EAAE,4BAA4B;EACtE;EACA;IACE,UAAU;IACV,oCAAoC,EAAE,iCAAiC;EACzE;AACF;;;;AAIA,oCAAoC;AACpC;EACE,yCAAyC,EAAE,uBAAuB;EAClE,WAAW,EAAE,8BAA8B;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,6CAA6C;AAC7C;EACE,yCAAyC,EAAE,sCAAsC;AACnF;AACA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;AACF;;;AAGA,+CAA+C;AAC/C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,aAAa;;;EAGb,kCAAkC,EAAE,6BAA6B;AACnE;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc,EAAE,4BAA4B;AAC9C;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc,EAAE,4BAA4B;EAC5C,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,cAAc,EAAE,6BAA6B;EAC7C,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".header-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.header-row span {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n}\r\n\r\n.header-row select {\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.profile-item,\r\n.selected-profile-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.profile-item span,\r\n.selected-profile-item span {\r\n  flex-grow: 1;\r\n}\r\n\r\n#graph-container {\r\n  width: 100%;\r\n  height: calc(100vh - 70px);\r\n  margin-top: 50px;\r\n}\r\n\r\n.move-button {\r\n  position: absolute;\r\n  top: 25px;\r\n  right: 19px;\r\n  cursor: grab;\r\n}\r\n\r\n.move-button.dragging {\r\n  cursor: grabbing;\r\n}\r\n\r\n.dragging-column {\r\n  opacity: 0.5;\r\n}\r\n\r\n/* Sticky search area */\r\n.search-area {\r\n  position: sticky;\r\n  top: 53px; /* Stick below the header card (adjust value based on header's height) */\r\n  /* z-index: 9; Ensure it stays below the header but above the content */\r\n  /* background-color: white; Ensure the background doesn't overlap with scrolling content */\r\n  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05); */\r\n  border-radius: 10px;\r\n  width: 100%;\r\n  /* margin-bottom: 10px; */\r\n}\r\n\r\n.search-row,\r\n.deck-platform-row,\r\n.checkbox-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n\r\n}\r\n\r\n.search-input,\r\n.platform-select {\r\n  width: 81%;\r\n  padding: 8px;\r\n  margin: 10px 0;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n}\r\n\r\n.filter-button,\r\n.icon-button,\r\n.move-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.checkbox {\r\n  opacity: 1;\r\n  cursor: pointer;\r\n  height: 12px;\r\n  width: 12px;\r\n}\r\n\r\n.platform-checkbox-row label {\r\n  font-size: smaller;\r\n}\r\n\r\n.platform-checkbox-row input[type=\"radio\"] {\r\n  appearance: radio;\r\n  width: 16px;\r\n  height: 16px;\r\n  background-color: #f30000;\r\n  border: 1px solid #dda1a1;\r\n  border-radius: 2px;\r\n  position: relative;\r\n  margin-right: 5px;\r\n}\r\n\r\n.platform-checkbox-row input[type=\"radio\"]:checked::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #65ccb7;\r\n  top: 3px;\r\n  left: 3px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.post-card {\r\n  border-radius: 10px;\r\n  margin-bottom: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  padding: 10px;\r\n  /* position: relative; */\r\n  transition: box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out;\r\n  /* z-index: 1; */\r\n  box-sizing: border-box;\r\n  margin-right: 6px;\r\n}\r\n\r\n.post-card.instagram,\r\n.post-card.linkedin,\r\n.post-card.twitter,\r\n.post-card.tiktok {\r\n  background-color: #fff;\r\n  color: black;\r\n}\r\n\r\n.post-card.facebook {\r\n  background: linear-gradient(90deg, #4267b2, #5fb9e2);\r\n  color: white;\r\n}\r\n\r\n.post-card.instagram {\r\n  background: linear-gradient(\r\n    45deg,\r\n    /* #774adf, */\r\n    #9648be,\r\n    #bc4596,\r\n    /* #d8447a,\r\n    #e94369,\r\n    #ef4363,\r\n    #ef535e, */\r\n    /* #f07f52, */\r\n    #f2c141\r\n  );\r\n  color: white;\r\n}\r\n\r\n.post-card.linkedin {\r\n  background-color: #0076b2;\r\n  color: white;\r\n}\r\n\r\n.post-card.twitter {\r\n  background: linear-gradient(90deg, #000000, #666a6b);\r\n  color: white;\r\n}\r\n\r\n.post-card.tiktok {\r\n  background: linear-gradient(45deg, #9300c7, #69c9d0);\r\n  color: white;\r\n}\r\n\r\n.card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-top: -4px;\r\n}\r\n\r\n.card-header .user-img {\r\n  width: 30px;\r\n  height: 30px;\r\n  border-radius: 15px;\r\n}\r\n\r\n.card-header .header-info {\r\n  flex-grow: 1;\r\n  margin-left: 8px;\r\n}\r\n\r\n.card-header h3 {\r\n  margin-top: 0px;\r\n  font-size: 14px;\r\n}\r\n\r\n.card-header p {\r\n  margin-top: -13px;\r\n  font-size: 14px;\r\n  color: #ffffff !important;\r\n}\r\n\r\n.card-header .header-info .time {\r\n  font-size: 0.8em;\r\n  color: grey;\r\n}\r\n\r\n.card-header .platform-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.card-header .social-icon a:hover img {\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.card-header .social-icon a:hover .facebook-icon {\r\n  background: #3b5998;\r\n  box-shadow: 0 0 5px #3b5998, 0 0 10px #3b5998;\r\n}\r\n\r\n.card-header .social-icon a:hover .instagram-icon {\r\n  background: #e4405f;\r\n  box-shadow: 0 0 5px #e4405f, 0 0 10px #e4405f;\r\n}\r\n\r\n.card-header .social-icon a:hover .linkedin-icon {\r\n  background: #0077b5;\r\n  box-shadow: 0 0 5px #0077b5, 0 0 10px #0077b5;\r\n}\r\n\r\n.card-header .social-icon a:hover .twitter-icon {\r\n  background: #1da1f2;\r\n  box-shadow: 0 0 5px #1da1f2, 0 0 10px #1da1f2;\r\n}\r\n\r\n.card-header .social-icon a:hover .tiktok-icon {\r\n  background: #69c9d0;\r\n  box-shadow: 0 0 5px #69c9d0, 0 0 10px #69c9d0;\r\n}\r\n\r\n.card-body {\r\n  background: none;\r\n}\r\n\r\n.date-time {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  text-align: left;\r\n  font-size: 0.9em;\r\n  color: #e2e2e2;\r\n}\r\n\r\n.date-time-text {\r\n  margin: 0;\r\n}\r\n\r\n.date,\r\n.time {\r\n  font-size: 0.9em;\r\n}\r\n\r\n.post-content {\r\n  overflow: x;\r\n  white-space: pre-wrap;\r\n  font-size: 16px;\r\n}\r\n\r\n.card-body p {\r\n  font-size: 14px;\r\n  transition: transform 0.3s ease;\r\n  width: 100%;\r\n  text-align: justify;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n\r\n.card-footer {\r\n  display: flex;\r\n  justify-content: space-around;\r\n}\r\n\r\n.footer-item {\r\n  font-size: 0.9em;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  transition: transform 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.highlighted {\r\n  font-weight: bold;\r\n  font-size: 1.1em;\r\n  font-family: Arial, sans-serif; /* or another bold and prominent font */\r\n}\r\n\r\n.footer-item:hover {\r\n  transform: scale(1.2);\r\n  color: #ff0000; /* or any color to highlight on hover */\r\n}\r\n\r\n/* Style for hashtags and mentions */\r\n.highlighted-text {\r\n  font-weight: bold;\r\n  font-size: 1.1em;\r\n  font-family: \"Courier New\", monospace; /* Bold and different font for differentiation */\r\n  margin-right: 1px; /* Add a small space between text and the hashtag */\r\n}\r\n\r\n/* Animation for icons in footer */\r\n.footer-item.animated-icon {\r\n  transition: transform 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.footer-item.animated-icon:hover {\r\n  transform: scale(2.2); /* Enlarges icon on hover */\r\n  color: #ff4500; /* Changes color on hover */\r\n}\r\n\r\n.zoomed {\r\n  transform: scale(1.1);\r\n  z-index: 100;\r\n}\r\n\r\n.zoomed .card-body p {\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.zoomed .card-body:hover p {\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* Dropdown Button */\r\n.dropbtn {\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  padding: 8px;\r\n  font-size: 16px;\r\n  border: none;\r\n  cursor: pointer;\r\n  /* width: 100%; */\r\n  text-align: center;\r\n  z-index: 1000;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n}\r\n\r\n.dropdown {\r\n  position: relative;\r\n  z-index: 9999; /* Ensure the dropdown wrapper is above other content */\r\n}\r\n\r\n/* Dropdown content */\r\n.dropdown-content {\r\n  display: none;\r\n  position: absolute;\r\n  background-color: #f9f9f9;\r\n  min-width: 295px;\r\n  max-height: 220px; /* Adjust max-height to ensure all platforms are visible */\r\n  overflow-y: auto; /* Enable scrolling if content overflows */\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n  z-index: 9999; /* Higher than the deck or other components */\r\n  top: 97px; /* Ensure the dropdown is placed below the button */\r\n  left: 0;\r\n  padding: 10px 0;\r\n  border-radius: 5px;\r\n}\r\n.dropdown-content.show {\r\n  display: block; /* Show when 'show' class is added */\r\n}\r\n/* Dropdown labels for each platform */\r\n.dropdown-content label {\r\n  color: black;\r\n  padding: 10px;\r\n  display: block;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Highlight effect when hovering over a platform */\r\n.dropdown-content label:hover {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n/* Ensure that clicking or hovering the button shows the dropdown */\r\n.dropdown:hover .dropdown-content,\r\n.dropdown:active .dropdown-content {\r\n  display: block;\r\n}\r\n\r\n.content {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  flex-wrap: nowrap;\r\n  gap: 10px;\r\n  margin-left: 275px; /* Adjusts margin from the sidebar */\r\n  /* padding: 10px 0px; */\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  margin-top: 10px;\r\n}\r\n\r\n/* Scrollbar Styles for Chrome, Safari, and Edge */\r\n.content::-webkit-scrollbar {\r\n  /* width: 8px; */\r\n  height: 10px; /* Set the width of the scrollbar */\r\n}\r\n\r\n.content::-webkit-scrollbar-track {\r\n  background: #f1e3e3; /* Background of the scrollbar track */\r\n  border-radius: 10px; /* Rounded corners of the scrollbar track */\r\n}\r\n\r\n.content::-webkit-scrollbar-thumb {\r\n  background-color: #65ccb7; /* Scrollbar thumb color */\r\n  border-radius: 10px; /* Rounded corners of the scrollbar thumb */\r\n  border: 2px solid #f1f1f1; /* Add space around the thumb */\r\n}\r\n\r\n/* Hover effect to make the scrollbar more visible */\r\n.content::-webkit-scrollbar-thumb:hover {\r\n  background-color: #0e9e81; /* Darker color when hovered */\r\n}\r\n\r\n.vertical-card.main-column {\r\n  flex-shrink: 0;\r\n  width: 325px; /* Set this to match your main column width */\r\n  height: calc(100vh - 44px); /* Makes it fit within the viewport */\r\n}\r\n.sub-column {\r\n  width: 320px;\r\n  height: calc(100vh - 106px);\r\n  background: rgba(255, 255, 255, 0.85); /* Light transparency for glass effect */\r\n  border-radius: 15px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  position: relative;\r\n  \r\n  -webkit-backdrop-filter: blur(10px); /* Safari support */\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); /* Soft professional elevation */\r\n}\r\n\r\n.sub-column::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  border-radius: 12px;\r\n  padding: 5px;\r\n  background: linear-gradient(135deg, \r\n  #833AB4 0%,   /* Instagram Purple */\r\n  #FD1D1D 25%,  /* Instagram Pink */\r\n  #FDCB82 50%,  /* Instagram Orange */\r\n  #1877F2 60%,  /* Facebook Blue */\r\n  #111111 80%,  /* Twitter Dark (Black) */\r\n  #69C9D0 90%,  /* TikTok Cyan */\r\n  #EE1D52 100%  /* TikTok Magenta */\r\n);\r\n\r\n\r\n  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\r\n  mask-composite: exclude;\r\n  pointer-events: none;\r\n  opacity: 0.8;\r\n}\r\n\r\n\r\n\r\n/* 3D Effect to Elevate the Sub-column */\r\n.sub-column::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 5px;\r\n  left: 5px;\r\n  right: 5px;\r\n  bottom: 5px;\r\n  border-radius: 15px;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  z-index: -1;\r\n}\r\n\r\n/* Scrollbar Styling - Sleek and Minimal */\r\n.sub-column::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.sub-column::-webkit-scrollbar-track {\r\n  background: transparent;\r\n  border-radius: 10px;\r\n}\r\n\r\n.sub-column::-webkit-scrollbar-thumb {\r\n  background: linear-gradient(180deg, #007BFF, #00C9FF);\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.sub-column::-webkit-scrollbar-thumb:hover {\r\n  background: linear-gradient(180deg, #0056b3, #0090ff);\r\n}\r\n\r\n\r\n/* Sticky Header */\r\n.header-card {\r\n  position: sticky;\r\n  top: 0; /* Stick to the top of the vertical-card container */\r\n  z-index: 10; /* Ensure it stays above other content */\r\n  background-color: #ffffff;\r\n  padding: 15px;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  /* margin-bottom: 10px; */\r\n  max-width: 100%;\r\n  word-wrap: break-word; /* Ensure wrapping within the header */\r\n  overflow-wrap: break-word; /* Make sure the text wraps correctly */\r\n  display: flex;\r\n  justify-content: center; /* Center title */\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n/* Ensuring title remains centered */\r\n.header-card .header-content {\r\n  flex: 1; /* Takes up available space, keeping text centered */\r\n  text-align: center;\r\n}\r\n\r\n/* Title Styling */\r\n.header-card .header-content h3 {\r\n  margin: 0;\r\n  font-size: 1.2em;\r\n  font-weight: bold;\r\n  white-space: normal; /* Allow text to wrap */\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  text-align: center;\r\n  max-width: 90%; /* Prevent text from overflowing */\r\n}\r\n\r\n/* Subtitle (Optional) */\r\n.header-card .header-content p {\r\n  margin: 5px 0 0 0;\r\n  font-size: 1em;\r\n  color: #555;\r\n}\r\n\r\n/* 3-Dot Menu Icon */\r\n.header-menu-icon {\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  cursor: pointer;\r\n  padding: 5px;\r\n  transition: 0.3s;\r\n}\r\n\r\n.header-menu-icon:hover {\r\n  color: #333;\r\n}\r\n\r\n\r\n.new-post-card {\r\n  border: 2px solid #69c9d0;\r\n  height: 100%;\r\n  align-items: center;\r\n}\r\n\r\n.post-card.transparent {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border: none;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.comment-section {\r\n  background: #3a5ba2;\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n  color: white;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.comment {\r\n  background: #2a3f5a;\r\n  border-radius: 5px;\r\n  padding: 8px;\r\n  margin: 5px 0;\r\n  font-size: 14px;\r\n  color: whitesmoke;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.comment .user {\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.comment .text {\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.comment .time {\r\n  font-size: 0.8em;\r\n  color: #ccc;\r\n  text-align: right;\r\n  margin-top: 5px;\r\n}\r\n\r\n.search-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: 5px;\r\n}\r\n\r\n.search-button img {\r\n  height: 35px;\r\n}\r\n\r\n.main-column {\r\n  display: block;\r\n}\r\n\r\n/* ------------------------------------------------------------------ */\r\n/* Base styles */\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\nhr {\r\n  width: calc(100% - 20px);\r\n  border: 1px solid rgba(112, 112, 112, 0.6);\r\n  margin-bottom: 20px;\r\n  opacity: 30%;\r\n}\r\n\r\n.main-content {\r\n  margin-left: 280px;\r\n  padding: 10px;\r\n  height: calc(100vh - 65px);\r\n}\r\n\r\n.popup-btn {\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  top: 10px;\r\n  left: 280px;\r\n}\r\n\r\n.popup-btn:hover {\r\n  transform: translateX(10px);\r\n}\r\n\r\n/* Popup styles */\r\n.popup {\r\n  display: none;\r\n  position: fixed;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 80%;\r\n  max-width: 800px;\r\n  height: auto;\r\n  background-color: white;\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\r\n  z-index: 1000;\r\n  border-radius: 10px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.popup-content {\r\n  position: relative;\r\n  padding: 20px;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.close-btn {\r\n  position: absolute;\r\n  right: 20px;\r\n  top: 10px;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n.popup-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-top: 40px;\r\n}\r\n\r\n.tab-btn {\r\n  flex: 1;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  border: none;\r\n  background-color: #f0f0f0;\r\n  border-radius: 5px 5px 0 0;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tab-btn:hover {\r\n  background-color: #ddd;\r\n}\r\n\r\n.tab-btn.active {\r\n  background-color: #65ccb7;\r\n  color: white;\r\n}\r\n\r\n.popup-tab-content {\r\n  display: none;\r\n  overflow-y: auto;\r\n  height: calc(100% - 80px);\r\n}\r\n\r\n.popup-tab-content.active {\r\n  display: block;\r\n}\r\n\r\n/* Profiles list container */\r\n.profiles-list,\r\n.selected-profiles-list,\r\n.selected-hashtags-list {\r\n  overflow-y: auto;\r\n  height: calc(100% - 80px);\r\n  border: 1px solid #ddd;\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* Buttons */\r\n.add-btn,\r\n.remove-btn {\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  width: 30px;\r\n  height: 30px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.remove-btn {\r\n  background-color: #ff6347;\r\n}\r\n\r\n.search-btn {\r\n  padding: 10px 20px;\r\n  font-size: 16px;\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  bottom: 10px;\r\n  right: 10px;\r\n}\r\n\r\n.search-btn:hover {\r\n  background-color: #53b39b;\r\n}\r\n\r\n/* Card styles */\r\n.vertical-card {\r\n  background-color: white;\r\n  padding: 10px;\r\n  width: 325px; /* Ensure it’s consistent with your layout */\r\n  height: calc(100vh - 44px); /* Makes it fit within the viewport */\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: 10px;\r\n\r\n  margin-right: 10px; /* Spacing between the columns */\r\n}\r\n\r\n.posts-wrapper {\r\n  background-color: white; /* Ensures a white background */\r\n  top: 0;\r\n  /* position: sticky; */\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  /* z-index: 1; */\r\n}\r\n/* .sub-column {\r\n    background-color: #f1f1f1;\r\n    height: auto;\r\n    padding: 7px 5px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-radius: 10px;\r\n    flex-direction: column;\r\n    width: 300px;\r\n    margin-left: 10px;\r\n    display: inline-block;\r\n} */\r\n\r\n.focused {\r\n  z-index: 10;\r\n}\r\n\r\n.background-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 5;\r\n}\r\n\r\n/* Hover effects */\r\n.post-card.facebook:hover,\r\n.post-card.instagram:hover,\r\n.post-card.linkedin:hover,\r\n.post-card.twitter:hover,\r\n.post-card.tiktok:hover {\r\n  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.add-column-button {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  width: 60px;\r\n  height: 60px;\r\n  background: linear-gradient(135deg, #007BFF, #0056b3); /* Gradient for sleek effect */\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%; /* Makes it a perfect circle */\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3); /* Smooth shadow for depth */\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n/* Hover Effect */\r\n.add-column-button:hover {\r\n  background: linear-gradient(135deg, #0056b3, #004080);\r\n  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.4);\r\n  transform: scale(1.1); /* Slightly enlarges button for better interaction */\r\n}\r\n\r\n/* Click Effect */\r\n.add-column-button:active {\r\n  transform: scale(0.95); /* Shrinks slightly when clicked */\r\n  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Floating Animation */\r\n@keyframes float {\r\n  0% { transform: translateY(0px); }\r\n  50% { transform: translateY(-5px); }\r\n  100% { transform: translateY(0px); }\r\n}\r\n\r\n.add-column-button {\r\n  animation: float 3s infinite ease-in-out;\r\n}\r\n\r\n\r\n@media (max-width: 480px) {\r\n  .content {\r\n    margin-left: 0;\r\n    padding: 5px;\r\n  }\r\n\r\n  .vertical-card {\r\n    width: 100%;\r\n    max-width: 200px;\r\n  }\r\n\r\n  .popup {\r\n    width: 100%;\r\n    height: auto;\r\n    padding: 0;\r\n  }\r\n\r\n  .popup-content {\r\n    padding: 10px;\r\n  }\r\n\r\n  .popup-btn {\r\n    font-size: 12px;\r\n    padding: 8px 15px;\r\n    left: 10px;\r\n  }\r\n\r\n  .search-btn {\r\n    padding: 8px 10px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n/* Style for the delete button */\r\n.delete-column-button {\r\n  position: absolute; /* Sets position to relative for moving within its normal flow */\r\n \r\n  right: 13px; /* Moves the button 20px right from its normal position */\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n  outline: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.delete-column-button img {\r\n  width: 20px;\r\n  height: 20px;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.delete-column-button:hover img {\r\n  transform: scale(1.1);\r\n}\r\n\r\n\r\n\r\n.dragging-column {\r\n  opacity: 0.5;\r\n  border: 2px dashed #ccc;\r\n}\r\n\r\n/* Ensure the content-wrapper uses flex for horizontal alignment */\r\n.content-wrapper {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n}\r\n\r\n.popup-error {\r\n  position: fixed;\r\n  top: 20%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: rgba(255, 0, 0, 0.8); /* Red background */\r\n  color: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  z-index: 1000;\r\n  text-align: center;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\r\n  animation: fadeInOut 3s forwards; /* Optional: add fade-in-out effect */\r\n}\r\n\r\n@keyframes fadeInOut {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n  10% {\r\n    opacity: 1;\r\n  }\r\n  90% {\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.sticky-header {\r\n  position: relative;\r\n  top: -10px;\r\n  z-index: 10;\r\n  background-color: white;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n\r\n/* Scrollbar Styles for Chrome, Safari, and Edge */\r\n.posts-wrapper::-webkit-scrollbar {\r\n  width: 8px; /* Set the width of the scrollbar */\r\n}\r\n\r\n.posts-wrapper::-webkit-scrollbar-track {\r\n  background: #f1f1f1; /* Background of the scrollbar track */\r\n  border-radius: 10px; /* Rounded corners of the scrollbar track */\r\n}\r\n\r\n.posts-wrapper::-webkit-scrollbar-thumb {\r\n  background-color: #888; /* Scrollbar thumb color */\r\n  border-radius: 10px; /* Rounded corners of the scrollbar thumb */\r\n  border: 2px solid #f1f1f1; /* Add space around the thumb */\r\n}\r\n\r\n/* Hover effect to make the scrollbar more visible */\r\n.posts-wrapper::-webkit-scrollbar-thumb:hover {\r\n  background-color: #555; /* Darker color when hovered */\r\n}\r\n\r\n.social-icon {\r\n  width: 30px; /* Increase width */\r\n  height: 30px; /* Increase height */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.platform-icon {\r\n  width: 30px; /* Set width for larger icon */\r\n  height: 30px; /* Set height for larger icon */\r\n  transition: transform 0.2s ease-in-out;\r\n}\r\n\r\n.platform-icon:hover {\r\n  transform: scale(1.2); /* Slightly enlarge on hover */\r\n}\r\n\r\n.date-time .sentiment-emoji {\r\n  font-size: 1.1em; /* Adjust emoji size */\r\n  margin-left: auto; /* Move it to the far right */\r\n  color: #ffffff;\r\n  font-weight: bold; /* Optional: color to distinguish the emoji */\r\n}\r\n\r\n/* Animation for icons in footer */\r\n.footer-item.animated-icon {\r\n  transition: transform 0.2s ease, color 0.2s ease;\r\n}\r\n\r\n.footer-item.animated-icon:hover {\r\n  transform: scale(1.2); /* Enlarges icon on hover */\r\n  color: #ff4500; /* Changes color on hover */\r\n}\r\n.sentiment-emoji {\r\n  font-size: 1.1em; /* Adjust emoji size */\r\n  margin-left: auto; /* Move it to the far right */\r\n  color: #000000; /* Optional: color to distinguish the emoji */\r\n  cursor: pointer;\r\n}\r\n.load-more-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 50px; /* Circular button width */\r\n  height: 50px; /* Circular button height */\r\n  padding: 12px;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  background-color: #65ccb7;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%; /* Makes the button circular */\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */\r\n  transition: all 0.3s ease;\r\n  position: relative; /* So the tooltip is correctly positioned */\r\n  margin-left: 43%;\r\n}\r\n.load-more-button {\r\n  animation: float 3s infinite ease-in-out;\r\n}\r\n.load-more-button:hover {\r\n  background-color: #42a894;\r\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2); /* Enhanced shadow on hover */\r\n  transform: scale(1.05); /* Slightly scale the button on hover */\r\n}\r\n\r\n.load-more-button:focus {\r\n  outline: none;\r\n}\r\n\r\n/* If you're using Font Awesome icons, the icon class should be like this */\r\n.load-more-icon {\r\n  font-size: 24px;\r\n  color: white; /* Make sure the icon is white */\r\n  display: inline-flex; /* Ensures it aligns well within the button */\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin: 0; /* Remove any default margin that may mess up alignment */\r\n}\r\n\r\n/* Tooltip styling */\r\n.load-more-button[title]:hover::after {\r\n  content: attr(title);\r\n  position: absolute;\r\n  top: -30px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 5px 10px;\r\n  background-color: #333;\r\n  color: white;\r\n  border-radius: 5px;\r\n  font-size: 14px;\r\n  white-space: nowrap;\r\n \r\n}\r\n\r\n.loading-indicator {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  color: #888;\r\n  margin: 20px 0;\r\n}\r\n\r\n/* General styles for image container */\r\n.attached-images {\r\n    margin-top: 10px;\r\n    display: grid;\r\n    gap: 10px;\r\n  }\r\n  \r\n  /* Single image layout */\r\n  .grid-1 {\r\n    grid-template-columns: 1fr;\r\n    justify-items: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  /* Two images in a horizontal layout */\r\n  .grid-2 {\r\n    grid-template-columns: 1fr 1fr;\r\n    justify-items: center;\r\n  }\r\n  \r\n  /* Three or more images layout */\r\n  .grid-3-special {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 10px;\r\n  }\r\n  \r\n /* Modal styles - set to appear above all components */\r\n .image-modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: rgba(0, 0, 0, 0.8); /* Adjust opacity if needed */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n}\r\n\r\n/* Modal content styling */\r\n.image-modal-content {\r\n  position: relative;\r\n  width: 80%; /* Adjust based on preference */\r\n  height: 80%; /* Adjust based on preference */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: transparent;\r\n  padding: 20px;\r\n  box-sizing: border-box;\r\n  overflow: hidden; /* Adjust if your content needs scrolling */\r\n}\r\n/* Close button styling */\r\n.image-close-modal {\r\n  position: absolute;\r\n  top: 20px; /* More padding to ensure it's easily clickable */\r\n  right: 20px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 30px; /* Larger size for better interaction */\r\n  color: white; /* Ensure visibility against the modal background */\r\n  cursor: pointer;\r\n}\r\n\r\n/* Modal images container */\r\n.modal-images {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n}\r\n\r\n\r\n/* Individual modal images */\r\n.modal-img {\r\n  max-width: 100%; /* Full width of the content area */\r\n  max-height: 100%; /* Full height without overflowing the modal */\r\n  object-fit: contain; /* Adjust to 'cover' if you want it to fill the area */\r\n  border-radius: 8px; /* Maintain rounded corners if desired */\r\n}\r\n\r\n.post-img {\r\n  width: 100%; /* Use 100% to make the image responsive within its container */\r\n  height: auto; /* Set height to auto to maintain the aspect ratio */\r\n  object-fit: cover; /* Cover ensures the image covers the container without distortion */\r\n  border-radius: 8px; /* Keeps the existing border-radius for rounded corners */\r\n  /* z-index: 100000 */\r\n  ;\r\n}\r\n\r\n.highlight {\r\n  background-color: yellow;\r\n  font-weight: bold;\r\n  color: red;\r\n}\r\n\r\n.toggle-text-button-deck {\r\n  color: #6eaeff;  /* Vibrant blue color for normal state */\r\n  cursor: pointer;\r\n  background: none;  /* Remove any background */\r\n  border: none;  /* Remove borders */\r\n  padding: 5px;  /* Adequate padding for better clickability */\r\n  outline: none;  /* Remove focus outline */\r\n  font-size: 16px;  /* Make the font size a bit larger for better readability */\r\n  transition: color 0.3s ease;  /* Smooth transition for color change */\r\n}\r\n\r\n.toggle-text-button-deck:hover,\r\n.toggle-text-button-deck:focus {\r\n  color: white;  /* A darker shade of blue on hover/focus for better visibility */\r\n  text-decoration: underline;  /* Adds an underline on hover/focus to indicate it's clickable */\r\n}\r\n\r\n/* Add to your global CSS */\r\n/* *, *:before, *:after {\r\n  box-sizing: border-box; \r\n} */\r\n\r\n\r\n\r\n\r\n.submit-search-button {\r\n  background: none; /* Remove background color */\r\n  border: none; /* Remove border */\r\n  color: inherit; /* Use the parent's text color */\r\n  cursor: pointer;\r\n  display: flex; /* Allows for flexbox centering */\r\n  align-items: center; /* Center content vertically */\r\n  justify-content: center; /* Center content horizontally */\r\n  padding: 0; /* Remove padding */\r\n  width: 30px; /* Set a fixed width */\r\n  height: 30px; /* Set a fixed height */\r\n  overflow: hidden; /* Keeps everything neat */\r\n  margin-left: 20px;\r\n  margin-right:-26 ; /* Move the button a bit to the right */\r\n}\r\n\r\n.submit-search-button span {\r\n  display: inline-block; /* Allows independent animation of the span */\r\n  font-size: 18px; /* Set initial size of the emoji */\r\n  animation: pulse 2s infinite ease-in-out; /* Animation applied continuously */\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    transform: scale(1); /* Original size */\r\n  }\r\n  50% {\r\n    transform: scale(1.5); /* Increased size */\r\n  }\r\n}\r\n\r\n/*_______________________________________________________________________________________________________________________________*/\r\n\r\n/* Loader */\r\n/* Loader Styles */\r\n.loader {\r\n  border: 3px solid #f3f3f3; /* Light grey */\r\n  border-top: 3px solid #3498db; /* Blue */\r\n  border-radius: 50%;\r\n  width: 20px;\r\n  height: 20px;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n\r\n/* copy link button */\r\n\r\n.copy-post-link-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  color: #fafafa; /* Matching theme color */\r\n  transition: color 0.3s ease-in-out;\r\n}\r\n\r\n.copy-post-link-button:hover {\r\n  color: #65ccb7; /* Darker on hover */\r\n}\r\n\r\n.copy-success {\r\n  color: rgb(247, 247, 247);\r\n  font-size: 12px;\r\n  margin-left: 5px;\r\n}\r\n\r\n/* video playing styles */\r\n/* Style for video container */\r\n/* Style for video container */\r\n/* Video Styles */\r\n.attached-videos {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.video-container {\r\n  max-width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.post-video {\r\n  width: 100%;\r\n  max-height: 250px;\r\n  border-radius: 8px;\r\n  background: black;\r\n  object-fit: cover;\r\n}\r\n\r\n\r\n\r\n.open-post-icon:hover {\r\n  color: #65ccb7 !important;\r\n}\r\n\r\n\r\n\r\n.date-picker {\r\n  padding: 8px;\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n  border: 1px solid #ccc;\r\n  margin-bottom: 10px;\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n}\r\n.date-picker:hover {\r\n  border-color: #65ccb7;\r\n}\r\n\r\n/* Modal Styling */\r\n\r\n\r\n/* Animation for Modal Appearance */\r\n@keyframes fadeIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateX(-50%) scale(0.9); /* Starts slightly smaller */\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(-50%) scale(1); /* Modal settles at normal size */\r\n  }\r\n}\r\n\r\n\r\n\r\n/* Elegant, Professional Highlight */\r\n.highlight {\r\n  background-color: rgba(255, 223, 88, 0.5); /* Soft golden yellow */\r\n  color: #333; /* Dark text for readability */\r\n  font-weight: bold;\r\n  padding: 2px 4px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.3s ease-in-out;\r\n}\r\n\r\n/* Slight glow effect for better visibility */\r\n.highlight:hover {\r\n  background-color: rgba(255, 200, 50, 0.7); /* Slightly stronger yellow on hover */\r\n}\r\n.sub-column-search-input {\r\n  width: 90%;\r\n  padding: 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ccc;\r\n  font-size: 14px;\r\n  margin-bottom: 5px;\r\n  margin-top: 5px;\r\n  transition: all 0.3s ease-in-out;\r\n  outline: none;\r\n  background: #f9f9f9;\r\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.sub-column-search-input:focus {\r\n  border-color: #007bff;\r\n  background: #fff;\r\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.4);\r\n}\r\n\r\n.sub-column-search-input::placeholder {\r\n  color: #999;\r\n  font-style: italic;\r\n}\r\n\r\n.sub-column-search-input:hover {\r\n  border-color: #888;\r\n}\r\n\r\n\r\n\r\n/* Advanced Aesthetic Spinner */\r\n.spinner {\r\n  width: 32px;\r\n  height: 32px;\r\n  display: inline-block;\r\n  position: relative;\r\n}\r\n\r\n.spinner::before,\r\n.spinner::after {\r\n  content: \"\";\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  animation: pulse 1.2s infinite ease-in-out;\r\n}\r\n\r\n.spinner::before {\r\n  border: 4px solid rgba(0, 123, 255, 0.2);\r\n  animation-delay: -0.6s;\r\n  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);\r\n}\r\n\r\n.spinner::after {\r\n  border: 4px solid rgba(0, 123, 255, 0.8);\r\n  border-top-color: transparent;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n/* Spin Animation */\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Subtle Pulse Animation */\r\n@keyframes pulse {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 0.8;\r\n  }\r\n  50% {\r\n    transform: scale(1.2);\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    transform: scale(1);\r\n    opacity: 0.8;\r\n  }\r\n}\r\n\r\n\r\n/* Container for the \"No Posts Found\" message */\r\n.no-posts-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  \r\n  padding: 20px;\r\n\r\n\r\n  animation: fadeIn 0.5s ease-in-out; /* Smooth fade-in animation */\r\n}\r\n\r\n/* Content inside the container */\r\n.no-posts-content {\r\n  text-align: center;\r\n  max-width: 400px;\r\n  padding: 20px;\r\n}\r\n\r\n/* Icon styling */\r\n.no-posts-icon {\r\n  margin-bottom: 20px;\r\n\r\n}\r\n\r\n.no-posts-icon svg {\r\n  width: 64px;\r\n  height: 64px;\r\n  color: #6b7280; /* Gray color for the icon */\r\n}\r\n\r\n/* Title styling */\r\n.no-posts-title {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #1f2937; /* Dark gray for the title */\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Description styling */\r\n.no-posts-description {\r\n  font-size: 16px;\r\n  color: #6b7280; /* Gray for the description */\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Keyframes for animations */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
